import React from 'react';
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        fontWeight: 'bold',
        textTransform: 'uppercase',
        fontSize: '1.5em',
        marginTop: '0.83em',
        marginBottom: theme.spacing(2),
        '& .MuiButtonBase-root': {
            paddingLeft: theme.spacing(1),
        },
        '& h2': {
            textTransform: 'uppercase',
            marginBottom: 0,
            marginTop: 0,
            textAlign: 'center'
        },
        '& h4': {
            textTransform: 'none',
            marginTop: 0,
            marginBottom: 0,
            textAlign: 'center',
            fontWeight: 'normal'
        }
    },
    textContainer: {
        position: 'relative',
        marginRight: 'auto',
        marginLeft: 'auto',
        textAlign: 'center',
        fontSize: '16px',
        '&.with-icon': {
            left: '-22px'
        }
    }
}));
export default ({ title, subtitle, onClick, children }) => {
    const classes = useStyles();
    return React.createElement("div", { className: classes.root },
        onClick && React.createElement(IconButton, { onClick: onClick },
            React.createElement(Icon, null, "arrow_back")),
        React.createElement("span", { className: `${classes.textContainer} ${onClick ? 'with-icon' : ''}` },
            title && React.createElement("h2", null, title),
            subtitle && React.createElement("h4", null, subtitle),
            !title && React.createElement("span", null, children)));
};
